import Vue from 'vue'
import App from './App.vue'
import router from './router'
//import store from "./store";
import { useMainStore } from '@/stores';

//import VueCompositionAPI from '@vue/composition-api'
import vuetify from "./plugins/vuetify";
import i18n from './i18n'
import { createPinia } from 'pinia';


//Vue.use(VueCompositionAPI)
//Vue.use(Vuetify)



const pinia = createPinia();


Vue.use(pinia)


Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
//store,
  useMainStore,
  i18n,
  render: h => h(App)
}).$mount('#app')
